<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="login-background">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="login-content">
      <!-- 左侧品牌展示区域 -->
      <div class="brand-section">
        <div class="brand-content">
          <div class="brand-logo">
            <i class="el-icon-goods"></i>
          </div>
          <h1 class="brand-title">Zac的小仓库</h1>
          <p class="brand-subtitle">智能商品管理系统</p>
          <div class="feature-list">
            <div class="feature-item">
              <i class="el-icon-goods"></i>
              <span>商品管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-video-camera"></i>
              <span>直播管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-folder"></i>
              <span>文件中心</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-notebook-1"></i>
              <span>备忘管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧登录表单区域 -->
      <div class="form-section">
        <el-card class="login-card" shadow="always">
          <div class="login-header">
            <h2 class="login-title">欢迎回来</h2>
            <p class="login-subtitle">请登录您的账户</p>
          </div>

          <el-form 
            ref="loginForm" 
            :model="loginForm" 
            class="login-form"
            :rules="loginRules"
            @submit.native.prevent="handleLogin"
          >
            <el-form-item prop="userName">
              <el-input
                v-model="loginForm.userName"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                size="large"
                clearable
                @keyup.enter="handleLogin"
              />
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                show-password
                size="large"
                clearable
                @keyup.enter="handleLogin"
              />
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                size="large"
                class="login-button"
                :loading="loading"
                @click="handleLogin"
              >
                <span v-if="!loading">登录</span>
                <span v-else>登录中...</span>
              </el-button>
            </el-form-item>
          </el-form>

          <div class="login-footer">
            <p class="footer-text">© 2024 Zac的小仓库. 保留所有权利.</p>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { authApi } from '@/api'
import { tokenStorage } from '@/utils/storage'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      loading: false,
      loginRules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 2, max: 20, message: '账号长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleLogin () {
      // 表单验证
      try {
        await this.$refs.loginForm.validate()
      } catch (error) {
        return
      }

      this.loading = true
      try {
        const response = await authApi.login(this.loginForm)
        console.log('登录响应:', response) // 调试用

        // 根据后端返回格式获取token
        let token = ''
        if (typeof response === 'string') {
          token = response
        } else if (response && response.token) {
          token = response.token
        } else if (response && response.data && response.data.token) {
          token = response.data.token
        } else {
          throw new Error('登录响应格式异常')
        }

        console.log('提取的token:', token) // 调试用
        console.log('token类型:', typeof token) // 调试用
        console.log('token长度:', token ? token.length : 0) // 调试用
        
        tokenStorage.setToken(token)
        
        // 验证token是否正确存储
        const storedToken = tokenStorage.getToken()
        console.log('存储后的token:', storedToken) // 调试用
        console.log('存储后token长度:', storedToken ? storedToken.length : 0) // 调试用
        
        this.$message.success('登录成功')

        // 检查重定向
        const redirect = this.$route.query.redirect || '/search'
        this.$router.push(redirect)
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error('登录失败，请检查账号密码')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.floating-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 主要内容区域 */
.login-content {
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 600px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  z-index: 2;
}

/* 左侧品牌区域 */
.brand-section {
  flex: 1;
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  position: relative;
  overflow: hidden;
}

.brand-content {
  text-align: center;
  color: white;
  position: relative;
  z-index: 1;
}

.brand-logo {
  font-size: 60px;
  margin-bottom: 20px;
  opacity: 0.9;
}

.brand-title {
  font-size: 36px;
  font-weight: 600;
  margin: 0 0 10px 0;
  letter-spacing: 1px;
}

.brand-subtitle {
  font-size: 16px;
  margin: 0 0 40px 0;
  opacity: 0.9;
}

.feature-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 40px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.feature-item:hover {
  opacity: 1;
}

.feature-item i {
  font-size: 18px;
}

/* 右侧登录表单区域 */
.form-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  border: none;
  box-shadow: none;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 10px 0;
}

.login-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.login-form {
  margin-bottom: 30px;
}

.login-form .el-form-item {
  margin-bottom: 25px;
}

.login-button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.3);
}

.login-footer {
  text-align: center;
  margin-top: 30px;
}

.footer-text {
  font-size: 12px;
  color: #C0C4CC;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .login-content {
    flex-direction: column;
    height: auto;
    margin: 20px;
  }
  
  .brand-section {
    padding: 40px;
  }
  
  .brand-title {
    font-size: 28px;
  }
  
  .feature-list {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .form-section {
    padding: 40px;
  }
}

@media (max-width: 768px) {
  .login-container {
    padding: 10px;
  }
  
  .login-content {
    margin: 0;
    border-radius: 15px;
  }
  
  .brand-section {
    padding: 30px;
  }
  
  .form-section {
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue